/**
 * 首页顶部分类菜单
 * GET /api/app/parentLabel/list（经 devServer 代理到后端）
 * 返回 [{ parentLabelCode, parentLabel }, ...]
 */
import axios from 'axios'

function normalizeRow(row) {
  if (!row || typeof row !== 'object') return null
  const code = String(row.parentLabelCode ?? row.code ?? row.labelCode ?? '').trim()
  const label = String(
    row.parentLabel ?? row.parentLabelName ?? row.name ?? row.labelName ?? ''
  ).trim()
  if (!label) return null
  return {
    parentLabelCode: code || label,
    parentLabel: label
  }
}

export function normalizeMenuList(payload) {
  const raw = Array.isArray(payload) ? payload : payload?.data ?? payload?.list ?? payload?.records
  if (!Array.isArray(raw)) return []
  return raw.map(normalizeRow).filter(Boolean)
}

/**
 * @returns {Promise<Array<{ parentLabelCode: string, parentLabel: string }>>}
 */
export async function fetchMenuList() {
  try {
    const { data: body } = await axios.get('/api/app/parentLabel/list')
    return normalizeMenuList(body)
  } catch (e) {
    console.warn('[parentLabel/list] 请求失败:', e?.message || e)
    return []
  }
}
